import { useNavigate } from 'react-router-dom';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';
import Card from '../../components/base/Card';

interface ProfileOption {
  id: string;
  title: string;
  icon: string;
  color: string;
  hasArrow?: boolean;
  action?: () => void;
}

const profileOptions: ProfileOption[] = [
  {
    id: 'personal-info',
    title: 'البيانات الشخصية',
    icon: 'ri-user-line',
    color: '#007AFF',
    hasArrow: true
  },
  {
    id: 'insurance-cards',
    title: 'بطاقات التأمين',
    icon: 'ri-bank-card-line',
    color: '#34C759',
    hasArrow: true
  },
  {
    id: 'payment-methods',
    title: 'طرق الدفع',
    icon: 'ri-bank-line',
    color: '#F9A826',
    hasArrow: true
  },
  {
    id: 'addresses',
    title: 'العناوين المحفوظة',
    icon: 'ri-map-pin-line',
    color: '#FF3B30',
    hasArrow: true
  },
  {
    id: 'language',
    title: 'اللغة',
    icon: 'ri-global-line',
    color: '#8E8E93',
    hasArrow: true
  },
  {
    id: 'notifications-settings',
    title: 'إعدادات الإشعارات',
    icon: 'ri-notification-line',
    color: '#007AFF',
    hasArrow: true
  },
  {
    id: 'support',
    title: 'الدعم الفني',
    icon: 'ri-customer-service-line',
    color: '#34C759',
    hasArrow: true
  },
  {
    id: 'contact',
    title: 'تواصل معنا',
    icon: 'ri-phone-line',
    color: '#F9A826',
    hasArrow: true
  },
  {
    id: 'about',
    title: 'حول التطبيق',
    icon: 'ri-information-line',
    color: '#8E8E93',
    hasArrow: true
  }
];

export default function Profile() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <TopNavigation 
        title="الملف الشخصي"
        showBack
        onBack={() => navigate('/')}
        rightAction={
          <button className="text-[#007AFF] text-sm font-medium">
            تعديل
          </button>
        }
      />
      
      <div className="pt-20 pb-24 px-4 space-y-6">
        {/* User Profile Header */}
        <Card padding="lg">
          <div className="text-center">
            <div className="w-24 h-24 bg-gradient-to-br from-[#007AFF] to-[#00B4DB] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-user-fill text-3xl text-white"></i>
            </div>
            <h2 className="text-xl font-bold text-[#333333] mb-1">محمد أحمد العلي</h2>
            <p className="text-[#7A7A7A] text-sm mb-3">mohammed.ali@email.com</p>
            <div className="flex items-center justify-center gap-4 text-sm">
              <div className="flex items-center gap-1 text-[#34C759]">
                <i className="ri-shield-check-fill"></i>
                <span>حساب موثق</span>
              </div>
              <div className="flex items-center gap-1 text-[#007AFF]">
                <i className="ri-vip-crown-fill"></i>
                <span>عضو مميز</span>
              </div>
            </div>
          </div>
        </Card>

        {/* Quick Stats */}
        <div className="grid grid-cols-3 gap-4">
          <Card padding="md" className="text-center">
            <div className="text-2xl font-bold text-[#007AFF] mb-1">12</div>
            <div className="text-xs text-[#7A7A7A]">حجز مكتمل</div>
          </Card>
          <Card padding="md" className="text-center">
            <div className="text-2xl font-bold text-[#34C759] mb-1">3</div>
            <div className="text-xs text-[#7A7A7A]">بطاقة تأمين</div>
          </Card>
          <Card padding="md" className="text-center">
            <div className="text-2xl font-bold text-[#F9A826] mb-1">8</div>
            <div className="text-xs text-[#7A7A7A]">نقاط المكافآت</div>
          </Card>
        </div>

        {/* Profile Options */}
        <div className="space-y-3">
          {profileOptions.map((option) => (
            <Card key={option.id} padding="md" onClick={option.action}>
              <div className="flex items-center gap-4">
                <div 
                  className="w-10 h-10 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: `${option.color}15` }}
                >
                  <i 
                    className={`${option.icon} text-lg`}
                    style={{ color: option.color }}
                  ></i>
                </div>
                
                <div className="flex-1">
                  <h3 className="font-medium text-[#333333] text-sm">{option.title}</h3>
                </div>
                
                {option.hasArrow && (
                  <i className="ri-arrow-left-s-line text-[#7A7A7A] text-lg"></i>
                )}
              </div>
            </Card>
          ))}
        </div>

        {/* Logout Button */}
        <Card padding="md">
          <button className="w-full flex items-center justify-center gap-3 text-[#FF3B30] font-medium">
            <i className="ri-logout-box-line text-lg"></i>
            <span>تسجيل الخروج</span>
          </button>
        </Card>

        {/* App Version */}
        <div className="text-center text-xs text-[#7A7A7A] pt-4">
          تكافل بلس الإصدار 1.0.0
        </div>
      </div>
      
      <BottomNavigation />
    </div>
  );
}
